function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    window.$th_refreshWishlistItems();
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','active-acc');
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        if(document.querySelector('body').classList.contains('open-size-chart')){
          document.querySelector('.size-chart-popup-wrap').innerHTML = '';
        }
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','open-currency','open-size-chart','open-quick-buy','active-acc');
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
      	document.querySelectorAll('.cart-count').forEach((cartCountItem) => {
          cartCountItem.innerHTML = '<span> [</span>'+cart_count+'<span>]</span>';
        });
      }else{
      	document.querySelectorAll('.cart-count').forEach((cartCountItem) => {
          cartCountItem.innerHTML = '';
        });
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
document.addEventListener('click', function (e) {
  const button = e.target.closest('.item-var .sel-var .value.click');
  const soldOutButton = e.target.closest('.inner-item-var-box .var.sold-out-var');
  if (soldOutButton) {
    const msg = document.querySelector('.sold-out-mess');
    msg.classList.add('active');
    setTimeout(() => {
      msg.classList.remove('active');
    }, 3000);
    return;
  }
  const allItems = document.querySelectorAll('.item-var.active');
  if (button) {
    const itemVar = button.closest('.item-var');
    allItems.forEach(el => {
      if (el !== itemVar) el.classList.remove('active');
    });
    itemVar.classList.toggle('active');
  } else {
    allItems.forEach(el => el.classList.remove('active'));
  }
});
document.addEventListener('click', function (e) {
  const addButton = e.target.closest('.sing-usp .usp-quick-add');
  if (addButton) {
    const line = addButton.getAttribute('data-id');
    if (line) {
      addItemNew(line);
    }
  }
});
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function addItemNew(line) {
  const data = {
    items: [{
      id: line,
      quantity: 1
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
      const addedItem = data.items[0];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: Shopify.currency.active,
          value: addedItem.price / 100,
          items: [{
            item_id: addedItem.product_id,
            item_name: addedItem.product_title,
            item_category: addedItem.product_type,
            item_variant: addedItem.variant_title,
            item_variant_id: addedItem.variant_id,
            price: addedItem.price / 100,
            quantity: 1
          }]
        }
      });
    })
    .catch((error) => {
      console.error('Add Error:', error);
    });
}

document.addEventListener('click', function (e) {
  const button = e.target.closest('.item-var-box .var.click');
  if (button) {
    const itemRow = button.closest('.item-row');
    const dataLine = itemRow?.getAttribute('data-line');
    const newVariantId = button.getAttribute('data-id');
    const nlSize = button.getAttribute('data-nl-size');
    const isFootwear = button.getAttribute('data-is-footwear') === 'true';
    const countryCode = button.getAttribute('data-iso-code');
    const countryName = button.getAttribute('data-country-name');
    

    if (dataLine && newVariantId) {
      // remove old & add new immediately with size properties
      switchVariant(dataLine, newVariantId, nlSize, isFootwear, countryCode, countryName);
    } else if (newVariantId) {
      addItemNew(newVariantId);
    }
  }
});
document.addEventListener('click', function (e) {
  const addButton = e.target.closest('.free-add-to-cart .add-btn');
  if (addButton) {
    const line = addButton.getAttribute('data-id');
    if (line) {
      addItemNew(line);
    }
  }
});
document.addEventListener('click', function (e) {
  const addButton = e.target.closest('.cat-qa .cart-qa-btn');
  if (addButton) {
    const line = addButton.getAttribute('data-id');
    if (line) {
      addItemNew(line);
    }
  }
});
// ---- helpers ---- //
function switchVariant(dataLine, newVariantId, nlSize, isFootwear, countryCode, countryName) {
  
  // Get the button element to read the displayed (converted) size
  const button = document.querySelector(`.item-var-box .var[data-id="${newVariantId}"]`);
  const displaySize = button ? button.textContent.trim() : nlSize;
  
  // Get current quantity from the cart
  const itemRow = document.querySelector(`.item-row[data-line="${dataLine}"]`);
  const qtyInput = itemRow ? itemRow.querySelector('.cart_qty') : null;
  const currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  
  const properties = displaySize !== nlSize 
    ? { 'Size guide': 'NL ' + nlSize + ' / ' + countryCode + ' ' + displaySize }
    : {};
  
  
  // First, get the current cart to find the exact line to remove
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      // Remove the item at the specified line
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: dataLine,
          quantity: 0
        }),
      });
    })
    .then((res) => res.json())
    .then((data) => {
      // Add the new variant
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ 
            id: newVariantId, 
            quantity: currentQty,
            properties: properties
          }]
        }),
      });
    })
    .then((res) => res.json())
    .then((data) => {
      load_cart();
    })
    .catch((err) => {
      console.error('Switch Error:', err);
      load_cart(); // Reload cart even on error to show current state
    });
}
// function addItemNew(line) {
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       items: [{ id: line, quantity: 1 }]
//     }),
//   })
//     .then((res) => res.json())
//     .then(() => {
//       load_cart();
//     })
//     .catch((err) => {
//       console.error('Add Error:', err);
//     });
// }

document.addEventListener('click', function(e) {
  const plusBtn = e.target.closest('.item_plus');
  if (plusBtn) {
    const centerQty = plusBtn.previousElementSibling;
    const input = centerQty.querySelector('input');
    const maxQty = parseInt(plusBtn.getAttribute('data-max'), 10);
    let currentQty = parseInt(input.value, 10) || 0;
    input.value = currentQty + 1;
    const newLine = plusBtn.getAttribute('data-line-item');
    console.log(plusBtn,'plus',newLine);
    const newQty = input.value;
    addItem(newLine, newQty);
    if(newQty == maxQty){
      console.log('match qty');
      // showCartError(plusBtn);
      // plusBtn.classList.add("disabled-plus");
    }
  }
});
document.addEventListener('click', function (e) {
  const minusBtn = e.target.closest('.item_minus');
  if (minusBtn) {
    const centerQty = minusBtn.nextElementSibling;
    const input = centerQty.querySelector('input');
    let currentQty = parseInt(input.value, 10) || 1;
    
    if (currentQty <= 1) {
      return;
    }
    // if (currentQty > 1) {
    input.value = currentQty - 1;
    const plusBtn = centerQty.nextElementSibling;
    if (plusBtn) {
      plusBtn.classList.remove("disabled-plus");
      hideCartError(plusBtn);
    }
    // }
    const newLine = minusBtn.getAttribute('data-line-item');
    const newQty = input.value;
    console.log('minus',newLine);
    addItem(newLine, newQty);
  }
});
function showCartError(plusBtn) {
  let errorElement = plusBtn.closest('.item-qty').querySelector('.cart-error');
  if (errorElement) {
    console.log('plus');
    plusBtn.classList.add("disabled-plus");
    errorElement.classList.add('active-error');
  }
}
function hideCartError(plusBtn) {
  let errorElement = plusBtn.closest('.item-qty').querySelector('.cart-error');
  if (errorElement) {
    console.log('minus');
    errorElement.classList.remove('active-error');
  }
}
function addItem(newLine, newQty) {
  const data = { line: newLine, quantity: newQty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    console.log(data,'added',newLine);
    if(data.status == 422){
      showCartError(document.querySelector(`.item_plus[data-line-item="${newLine}"]`));
      let input = document.querySelector(`.item_plus[data-line-item="${newLine}"]`).closest('.item-qty').querySelector('.cart_qty');
      if(input) input.value = document.querySelector(`.item_plus[data-line-item="${newLine}"]`).getAttribute('data-max');
      return;
    } else {
      load_cart();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


document.addEventListener("click", function (e) {
  const moveBtn = e.target.closest(".move-to-wishlist");
  if (!moveBtn) return;

  const wrapper = moveBtn.closest(".remove-item");
  if (!wrapper) return;

  document.querySelectorAll(".move-to-wishlist").forEach(btn => {
    btn.classList.add("disabled");
  });

const wishlistBtn = wrapper.querySelector(".th_wl_col_btn .th_wl_button");
  const removeBtn   = wrapper.querySelector(".item-remove");

  if (wishlistBtn) {
    wishlistBtn.style.display = "block";
    wishlistBtn.click();
    wishlistBtn.style.display = "none";
  }

  if (removeBtn) removeBtn.click();
});